import { ProtectedSidebarLink } from '@britishcouncil/react-admin';
import { ROUTING_PATHS } from 'const';
import { OrganisationStructureContextFilter, useAppPermissions } from 'core';
import { SemanticICONS } from 'semantic-ui-react';
import { generatePath } from 'react-router';
import { DebouncedLoader, LockingLoader } from 'components';
import { useAllowedActions } from 'hooks';

export const Sidebar = () => {
  const { speakingSessions, examDatesForLocations, lrwSessions, testCentreOverview } =
    ROUTING_PATHS;
  const { permissionLoadingContext } = useAppPermissions();
  const { canViewExamDatesForLocations, canViewSpeakingSession, canViewLrwSession } =
    useAllowedActions();

  return (
    <>
      <DebouncedLoader
        inline="centered"
        isFetching={permissionLoadingContext.isLoading}
        margin="1rem 0 1rem 0"
      />
      <LockingLoader isFetching={permissionLoadingContext.isFetching} />
      <OrganisationStructureContextFilter filters={testCentreOverview.filters}>
        <ProtectedSidebarLink
          icon="calendar alternate"
          name="Planned exams overview"
          to={generatePath(testCentreOverview.absolutePath)}
          requiresAny={testCentreOverview.requiresAny}
        />
      </OrganisationStructureContextFilter>
      <OrganisationStructureContextFilter filters={examDatesForLocations.filters}>
        <ProtectedSidebarLink
          icon="calendar alternate"
          name="Exam dates for locations"
          to={examDatesForLocations.absolutePath}
          isVisible={canViewExamDatesForLocations}
        />
      </OrganisationStructureContextFilter>
      <OrganisationStructureContextFilter filters={speakingSessions.filters}>
        <ProtectedSidebarLink
          icon="comment"
          name="Plan Speaking"
          to={generatePath(speakingSessions.absolutePath)}
          isVisible={canViewSpeakingSession}
          matchExactPathForActive={false}
        />
      </OrganisationStructureContextFilter>
      <OrganisationStructureContextFilter filters={lrwSessions.filters}>
        <ProtectedSidebarLink
          icon={'shapes' as unknown as SemanticICONS}
          name="Plan Listening, Reading, Writing"
          to={generatePath(lrwSessions.absolutePath)}
          isVisible={canViewLrwSession}
          matchExactPathForActive={false}
        />
      </OrganisationStructureContextFilter>
    </>
  );
};
